'use strict';

/**
 * Test whether value is a boolean
 * @param {*} value
 * @return {boolean} isBoolean
 */
exports.isBoolean = function(value) {
  return typeof value == 'boolean';
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/utils/boolean.js
// module id = 931
// module chunks = 0